module.exports = __webpack_public_path__ + "images/2290c99353cd34a00536d0616fe8e435.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/thesuperlatives-characters04.jpg
// module id = ./webpack/assets/img/thesuperlatives-characters04.jpg
// module chunks = 0